import axios from 'axios';
import React, { useState, useEffect, useContext } from 'react';

import { logAmplitudeEvent } from '../../App';
import { AuthContext } from '../../context/auth_context';
import { AdminPostsContext } from '../../context/posts_context';
import '../../stylesheets/admin_post_widget.scss';

function PostWidget() {
    const { posts, postsDispatch } = useContext(AdminPostsContext);
    const { auth } = useContext(AuthContext);
    const [search, setSearch] = useState('');

    useEffect(() => {
        if (search.length > 0) {
            axios(
                `/api/posts/search?sort=_id:-1&search_for=${search}&limit=5&filter=is_quarantined:false,is_private:false`,
                {
                    method: 'get',
                    withCredentials: true,
                },
            ).then((res) => {
                postsDispatch({
                    posts: res.data.data,
                    type: 'SET_POSTS',
                });
            });
        } else {
            axios('/api/posts?sort=_id:-1&limit=5&filter=is_private:false', {
                method: 'get',
                withCredentials: true,
            }).then((res) => {
                postsDispatch({
                    posts: res.data.data,
                    type: 'SET_POSTS',
                });
            });
        }
    }, [search]);

    const quarantinePost = (e, _id) => {
        e.preventDefault();
        axios('/api/posts/moderate', {
            method: 'delete',
            data: { _id },
            withCredentials: true,
        }).then((res) => {
            logAmplitudeEvent(
                'admin:post:manual_quarantine',
                JSON.parse(res.config.data),
            );
            postsDispatch({
                type: 'DEL_POST',
                post: JSON.parse(res.config.data),
            });
        });
    };

    const handleSeeMore = (e) => {
        e.preventDefault();
        const fetchAfter =
            Object.values(posts)[Object.values(posts).length - 1]._id;
        if (search.length > 0) {
            axios(
                `/api/posts/search?sort=_id:-1&search_for=${search}&limit=5&filter=is_quarantined:false,is_private:false&before_id=${fetchAfter}`,
                {
                    method: 'get',
                    withCredentials: true,
                },
            ).then((res) => {
                postsDispatch({
                    posts: res.data.data,
                    type: 'RECEIVE_POSTS',
                });
            });
        } else {
            axios(
                `/api/posts?sort=_id:-1&limit=5&filter=is_private:false&before_id=${fetchAfter}`,
                {
                    method: 'get',
                    withCredentials: true,
                },
            ).then((res) =>
                postsDispatch({
                    posts: res.data.data,
                    type: 'RECEIVE_POSTS',
                }),
            );
        }
    };

    return (
        <div className="manage-posts-card">
            <h2>All Posts</h2>
            <div className="search-posts-form">
                <label htmlFor="search-posts">Search Posts:</label>
                <input
                    name="search-posts"
                    type="text"
                    placeholder="Starts with..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </div>
            <div className="posts-list">
                {Object.values(posts)?.length !== 0 &&
                    Object.values(posts)?.map((post) => (
                        <div className="post-tile" key={post?._id}>
                            <div className="post-user-info">
                                <div className="post-username">
                                    <p>
                                        <b>{post?.author?.username}</b>
                                    </p>
                                </div>
                            </div>
                            <div className="post-content">{post?.content}</div>
                            <div className="post-btns">
                                <button
                                    className="post-delete-btn"
                                    onClick={(e) =>
                                        quarantinePost(e, post?._id)
                                    }
                                >
                                    Quarantine
                                </button>
                            </div>
                        </div>
                    ))}
            </div>
            <div className="posts-see-more">
                <button onClick={handleSeeMore}>See More</button>
            </div>
        </div>
    );
}

export default PostWidget;
